<script setup lang="ts">
import { useSearchOverlay } from '~/composables/useSearchOverlay'
import { useUserStore } from '@/store/user'
import PGlobalNotify from '@/components/ui/PGlobalNotify/PGlobalNotify.vue'

const { isSearchOverlayVisible } = useSearchOverlay()

const { fetchUser } = useUserStore()
await fetchUser()
</script>

<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <p-mobile-search-overlay v-model="isSearchOverlayVisible" />
    <p-global-notify />
  </div>
</template>

<style lang="scss" scoped>
html,
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}
</style>
